import { render } from "./HomePageFeaturedArticles.vue?vue&type=template&id=6f9f70bf&scoped=true"
import script from "./HomePageFeaturedArticles.vue?vue&type=script&lang=js"
export * from "./HomePageFeaturedArticles.vue?vue&type=script&lang=js"

import "./HomePageFeaturedArticles.vue?vue&type=style&index=0&id=6f9f70bf&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9f70bf"]])

export default __exports__